import React from "react";
import "./App.css";

import Aos from "aos";
import "aos/dist/aos.css";
// import { Techstacks } from "./Components/About/Techstacks";
import Navbar from "./Components/Navbar";
// import About from "./Components/About/About";
import Home from "./Components/Pages/Home";
import { Introduction } from "./Components/Pages/Introduction";
import { Timeline } from "./Components/About/Timeline";
import { Techstacks } from "./Components/About/Techstacks";
import { Projects } from "./Components/Pages/Projects/Projects";
import { Contact } from "./Components/Pages/Contact/Contact";
import { ScrollToTop } from "./Components/ScrollToTop/ScrollToTop";
// import { ScrollToTop } from "./Components/ScrollToTop/ScrollToTop";
export default function App() {
  // const { themename } = React.useContext(ThemeContext);
  React.useEffect(() => {
    Aos.init({ duration: 1300 });
  }, []);
  return (
    <div id="top" className="app">
      <Navbar />
      <Home />
      <Introduction />
      <Timeline />
      <Techstacks />
      <Projects />
 
      <br />
      <Contact />
      <br />
      <ScrollToTop />
      <br />
      <br />
      <h1
        style={{ color: "#ff9838", fontSize: "x-large", textAlign: "center" }}
      >
        Made With 💌💌
      </h1>
    </div>
  );
}
